<template>
	<div ref="root" class="panel-body">
	  <slot />
	</div>
  </template>
  
  <script setup>
  import { ref } from "vue";
  
  // Referencia al DOM raíz
  const root = ref(null);
  
  // Exponer explícitamente el elemento raíz
  defineExpose({
	root, // Ahora el componente padre puede acceder a `panelBodyRef.value.root`
  });
  </script>